import api from "./apiClient";

export const sendOtpApi = (mobile) => api.post("/auth/send-otp", { mobile });

export const verifyOtpApi = (mobile, otp) =>
  api.post("/auth/verify-otp", { mobile, otp });

export const updateProfileApi = (profileData) =>
  api.put("/user/profile", profileData);

export const fetchMeApi = () => api.get("/auth/me");
